<template>
    <!-- Ohne Kategorien: heutiges Verhalten (ein taggbares Multiselect) -->
    <tbody v-if="!hasCategories">
        <tr>
            <th><label class="label">{{label}}:</label></th>
            <td>
                <multiselect
                    v-bind:options="options"
                    v-model="tags"
                    v-bind:taggable="true"
                    class="is-shorter"
                    multiple
                    v-on:tag="newTag => { value.push(newTag); }"
                >
                    <span slot="caret" ></span>
                </multiselect>
                <p v-if="errors" class="help is-danger">{{ errors }}</p>
            </td>
        </tr>
    </tbody>
    <!-- Mit Kategorien: ein Select je Kategorie + "Sonstige"-Bucket -->
    <tbody v-else class="tag-category-rows">
        <tr v-for="category in sortedCategories" :key="'tagcat' + category.id">
            <th>
                <label class="label">
                    {{ category.name }}<span v-if="category.mandatory" class="has-text-danger">*</span>:
                </label>
            </th>
            <td>
                <multiselect
                    :options="category.valueList || []"
                    :multiple="category.multiple"
                    :value="categoryValue(category)"
                    class="is-shorter"
                    placeholder="Tag wählen"
                    @input="input => setCategoryValue(category, input)"
                >
                    <span slot="caret" ></span>
                </multiselect>
            </td>
        </tr>
        <tr>
            <th><label class="label">Tags:</label></th>
            <td>
                <multiselect
                    :options="[]"
                    :value="uncategorizedValue"
                    v-bind:taggable="true"
                    class="is-shorter"
                    multiple
                    placeholder="Freien Tag hinzufügen"
                    @tag="newTag => { value.push(newTag); }"
                    @input="input => setUncategorizedValue(input)"
                >
                    <span slot="caret" ></span>
                </multiselect>
                <p v-if="errors" class="help is-danger">{{ errors }}</p>
            </td>
        </tr>
    </tbody>
</template>

<script>

import Multiselect from "@components/form/Multiselect";

export default {
    props: {
        value: { required: true },
        label: { default: 'Tags'},
        options: {  default: () => {} },
        categories: { type: Array, default: () => [] },
        errors: { type: String, default: null },
    },

    computed: {
        hasCategories() {
            return this.categories && this.categories.length > 0;
        },

        sortedCategories() {
            return [...this.categories].sort((a, b) => a.position - b.position);
        },

        allCategoryValues() {
            return this.categories.reduce((all, category) => all.concat(category.valueList || []), []);
        },

        uncategorizedValue() {
            return (this.value || []).filter(tag => !this.allCategoryValues.includes(tag));
        },

        tags: {
            get: function () { return this.value; },
            set: function (value) { this.$emit('input', value) }
        }
    },

    methods: {
        categoryValue(category) {
            const selected = (this.value || []).filter(tag => (category.valueList || []).includes(tag));
            return category.multiple ? selected : (selected[0] || null);
        },

        // Value-Contract bleibt flaches Array: Auswahl der Kategorie ersetzt nur deren Werte
        setCategoryValue(category, input) {
            const selected = Array.isArray(input) ? input : (input ? [input] : []);
            const others = (this.value || []).filter(tag => !(category.valueList || []).includes(tag));
            this.$emit('input', [...others, ...selected]);
        },

        setUncategorizedValue(input) {
            const selected = Array.isArray(input) ? input : (input ? [input] : []);
            const categorized = (this.value || []).filter(tag => this.allCategoryValues.includes(tag));
            this.$emit('input', [...categorized, ...selected]);
        },
    },

    components: {
        Multiselect
    }
}
</script>
